<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="3">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <MultiplaEscolha
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="2">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
              :disabled="veiculosDisabled"
            />
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <MultiplaEscolha
              ref="equipamentosSelect"
              lazy
              get-url="getEquipamentoslazy"
              :request-data="equipamentosLazyRequestData"
              v-bind:selected-items.sync="idEquipamentosSelected"
              text="cod_equipamento"
              value="id_equipamento"
              :label="$tc('equipment.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
              :disabled="equipamentosDisabled"
            />
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-data-table :headers="headers" :items="historico" sort-by="p_envio_operacao" :sort-desc="false" dense
      class="elevation-7 no__wrap no__grey__lines" locale="pt" :loading="loading"
      :loading-text="$t('system.messages.loading')" :search="search"
      style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;" @update:sort-by="updateSort($event)"
      @update:sort-desc="updateSortDesc($event)">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">
            <span>{{ $t('relMaintenanceHistory.title') }}</span>
            <br />
            <v-chip color="#4a4a4a90" small style="margin-right: 2px; width: 80px; justify-content: center;">{{ legenda
              }}</v-chip>
            <v-chip color="#4a4a4a90" small
              style="margin-right: 2px; width: 80px; justify-content: center;">{{ $t('relMaintenanceHistory.percentageSend') }}</v-chip>
            <v-chip color="#4a4a4a90" small
              style="margin-right: 2px; width: 80px; justify-content: center;">{{ $t('relMaintenanceHistory.percentageValid') }}</v-chip>
            <v-chip color="#4a4a4a90" small
              style="margin-right: 2px; width: 80px; justify-content: center;">{{ $t('relMaintenanceHistory.bill') }}</v-chip>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('relVehicleKm.filter')" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>
                
                <v-menu offset-y :close-on-content-click="false" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      dark
                      small
                      class="mb-2 mr-2"
                      fab
                    >
                      <v-icon>mdi-filter</v-icon>
                    </v-btn>
                  </template>
                  <v-card min-width="300">
                    <v-card-title class="text-h6">
                      <v-icon left>mdi-filter</v-icon>
                      {{$t('operation.filtersTitle')}}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-text-field
                        v-model="filtroDiasAtivo"
                        :rules="[v => !isNaN(v) || $t('relMaintenanceHistory.rules.validNumber'), v => v >= 0 || $t('relMaintenanceHistory.rules.biggerThanZero')]"
                        :label="$t('relMaintenanceHistory.days')"
                        dense
                        outlined
                        class="mb-3"
                      ></v-text-field>
                      
                      <v-select
                        v-model="filtroStatusManutencao"
                        :items="statusManutencaoOptions"
                        :label="$t('relMaintenanceHistory.statusMaintenance')"
                        dense
                        outlined
                        class="mb-3"
                      ></v-select>
                      
                      <v-row>
                        <v-col cols="6">
                          <v-btn
                            color="primary"
                            small
                            block
                            @click="aplicarFiltros"
                          >
                            {{$t('button.apply')}}
                          </v-btn>
                        </v-col>
                        <v-col cols="6">
                          <v-btn
                            color="grey"
                            small
                            block
                            @click="limparFiltros"
                          >
                            {{$t('button.clear')}}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>
                
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="abrirConfiguracoesLimites">
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>Configurar limites de %</span>
          </v-tooltip>

          <vue-json-to-csv :json-data="historicoSorted" :csv-title="'historicomanutencao'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <ExportTablePdf :title="$t('relMaintenanceHistory.title')" :content="historicoSorted" :headers="headers"
            filename="historicomanutencao"
            :subtitle="`${razaoSocial} | ${$t('relVehicleKm.refDate')}: ${dataPdfInicial} - ${dataPdfFinal}`"
            :unwrap-object="true" :object-items-to-show="4" :horizontal-page-break="true" :font-size="8">
          </ExportTablePdf>

                </v-toolbar>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                    <td v-if="byVeiculo" v-on:click="linkStatus(item.numero_ordem, 1)"><v-icon>mdi-information-outline</v-icon></td>
                    <td v-if="byVeiculo">{{ item.numero_ordem }}</td>
                    <td v-if="byVeiculo">{{ item.nome_tipo_equipamento || '-' }}</td>
                    <td v-if="byEquipamento" v-on:click="linkStatus(item.numero_ordem, 1)"><v-icon>mdi-information-outline</v-icon></td>
                    <td v-if="byEquipamento">{{ item.cod_equipamento }}</td>
                    <td v-if="byEquipamento">{{ item.nome_tipo_equipamento || '-' }}</td>
                    <td v-for="day in headersHistorico" :key="`${item.id_veiculo || item.id_equipamento}-${day.value}`">
                        <v-chip :color="getColorIcon(item[day.value])" dark small style="margin-right: 2px; margin-top: 5px; justify-content: center;" >{{ item[day.value] ? item[day.value].codigo : '-' }}</v-chip>
                        <v-chip :color="getColorIcon(item[day.value])" dark small style="margin-right: 2px; margin-top: 5px; width: 60px; justify-content: center;" >{{ item[day.value] ? item[day.value].envio : '-' }}</v-chip>
                        <v-chip :color="getColorIcon(item[day.value])" dark small style="margin-right: 2px; margin-top: 5px; width: 60px; justify-content: center;" >{{ item[day.value] ? item[day.value].validas : '-' }}</v-chip>
                        <v-chip :color="getColorIcon(item[day.value])" dark small style="margin-right: 2px; margin-top: 5px; width: 60px; justify-content: center;" >{{ item[day.value] ? item[day.value].bilhetagem : '-' }}</v-chip>
                    </td>
                </tr>
            </template>
        </v-data-table>
      </v-container>
</template>

<script>

  import apiController from '@/utils/apiController';
  import DateUtils from "../utils/dateutils";
  import VueJsonToCsv from "vue-json-to-csv";
  import ExportTablePdf from "./ExportTablePdf.vue";
  import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
  import LazySelect from './Selects/LazySelect.vue';

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf,
    MultiplaEscolha,
    LazySelect,
  },
  data: () => ({
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    user: null,
    token: null,
    config: null,
    loading: false,
    relManutencaoTiposEquipamentos: {
      rastreadores: [],
      validadores_rastreadores_bilhetagem: [],
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    empresaRazaoSocial: null,
    idLinhaSelected: [],
    idEquipamentosSelected: [],
    search: "",
    unidadesSelecionadas: [],
    idVeiculosSelected: [],
    historico: [],
    historicoCompleto: [],
    toPivot: [],
    veiculosDisabled: false,
    timeProps: {
      useSeconds: true,
    },
    headersHistorico: [],
    headersHistoricoCompleto: [],
    formValidado: false,
    equipamentosDisabled: false,
    sortBy: null,
    sortDesc: false,
    byVeiculo: false,
    byEquipamento: false,
    filtroDiasAtivo: null,
    syncingSelection: false,
    veiculosCatalogo: {},
  }),
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    idVeiculosSelected(val) {
      if (this.syncingSelection) return;
      if (val && val.length > 0) {
        this.equipamentosDisabled = true;
        this.clearEquipamentosSelection();
      } else {
        this.equipamentosDisabled = false;
      }
    },
    idEquipamentosSelected(val) {
      if (this.syncingSelection) return;
      if (val && val.length > 0) {
        this.veiculosDisabled = true;
        this.clearVeiculosSelection();
      } else {
        this.veiculosDisabled = false;
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.getConfig();
    this.initialize();
  },
  computed: {
    statusManutencaoOptions() {
      return [
      { text: this.$t('operation.all'), value: 'todos' },
      { text: this.$t('relMaintenanceHistory.withProblems'), value: 'com_problemas' },
      { text: this.$t('relMaintenanceHistory.withoutProblems'), value: 'sem_problemas' }
    ];

    },
    filtroStatusManutencao() {return this.$t('operation.all')},
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    razaoSocial() {
      return this.empresaRazaoSocial || this.$t('company.allTheCompanies');
    },
    dataPdfInicial() {
      return this.dti ? this.dti.toLocaleString() : null;
    },
    dataPdfFinal() {
      return this.dtf ? this.dtf.toLocaleString() : null;
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    yesterday() {
      let d = new Date();
      d.setDate(d.getDate() - 1);
      return d.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday,
      };
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min,
        max: this.yesterday,
      };
    },
    historicoSorted() {
      if (!this.sortBy) {
        return this.historico;
      }
        
      return [...this.historico].sort((a, b) => {
        let result = 0;
        if (a[this.sortBy] > b[this.sortBy]) {
          return 1
        } else if (a[this.sortBy] == b[this.sortBy]) {
          result = 0;
        } else {
          result = -1;
        }
        return this.sortDesc ? -1 * result : result;
      });
    },
    headersBase() {
      if (this.byVeiculo) {
        return [
          { text: this.$t('vehicle.id'), value: "id_veiculo", align: " d-none" },
            { text: "Ação" },
          { text: this.$tc('vehicle.self', 1), value: "numero_ordem" },
          { text: this.$t('relMaintenanceHistory.otherEquipment.type'), value: "nome_tipo_equipamento" }
        ];
      }

      if (this.byEquipamento) {
        return [
          { text: this.$t('equipment.id'), value: "id_equipamento", align: " d-none" },
            { text: "Ação" },
          { text: this.$tc('equipment.self', 1), value: "cod_equipamento" },
          { text: this.$t('relMaintenanceHistory.otherEquipment.type'), value: "nome_tipo_equipamento" }
        ];
      }

      return [];
    },
    // Cabeçalho da tabela da 1ª aba: colunas base (veículo/equipamento) + uma
    // coluna por dia, cujo "text" é a data (dia_extenso). É isso que faz a data
    // aparecer em cima de cada coluna.
    headers() {
      return [...this.headersBase, ...this.headersHistorico];
    },
    legenda() {
      if (this.byEquipamento) {
        return this.$tc('vehicle.self', 1);
      }
      return this.$tc('equipment.self', 1);
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
    equipamentosLazyRequestData() {
      // Só exige vínculo com veículo (necessário para o histórico).
      // Não filtra por tipos aqui: a config de manutenção pode não bater com
      // equipamentos vinculados e o select ficava vazio.
      return {
        ...this.lazySelectRequestData,
        require_veiculo: true,
      };
    },
  },
  methods: {
    filtraItensLazyParaIds(dados) {
      if (!dados || !Array.isArray(dados)) {
        return [];
      }
      let filtrados = dados;
      if (this.idEmpresaSelected) {
        filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
      } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
        filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
      }
      if (this.unidadesSelecionadas && this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        filtrados = filtrados.filter((d) => {
          if (Array.isArray(d.unidades) && d.unidades.length > 0) {
            return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
          }
          if (d.id_unidade != null && d.id_unidade !== '') {
            return selecionadas.includes(Number(d.id_unidade));
          }
          if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
            return true;
          }
          return selecionadas.includes(-1);
        });
      }
      return filtrados;
    },
    async resolveLazySelectIds(refName, selectedIds, valueKey, requestDataOverride = null) {
      if (Array.isArray(selectedIds) && selectedIds.length > 0) {
        return { ids: selectedIds, implicit: false };
      }
      const selectRef = this.$refs[refName];
      if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
        return { ids: [], implicit: true };
      }
      const override = requestDataOverride != null
        ? requestDataOverride
        : this.lazySelectRequestData;
      const { items } = await selectRef.fetchAllLazyItems({
        search: '',
        requestDataOverride: override,
      });
      const ids = this.filtraItensLazyParaIds(items || [])
        .map((item) => item[valueKey])
        .filter((id) => id != null && id !== '');
      return { ids, implicit: true };
    },
    getEquipamentoSelectPorId() {
      const cache = (this.$refs.equipamentosSelect && this.$refs.equipamentosSelect.selectedItemCache) || {};
      return Object.keys(cache).reduce((acc, key) => {
        const item = cache[key];
        if (item && item.id_equipamento != null) {
          acc[Number(item.id_equipamento)] = item;
        }
        return acc;
      }, {});
    },
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    filtraVeiculosParaRelatorio(veiculos) {
      let filtrados = Array.isArray(veiculos) ? veiculos : [];
      if (this.idEmpresaSelected) {
        filtrados = filtrados.filter((v) => v.id_empresa == this.idEmpresaSelected);
      }
      return filtrados.filter((v) => this.passaFiltroUnidades(v));
    },
    formatDiaExtenso(date) {
      const d = String(date.getDate()).padStart(2, '0');
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },
    diasDoPeriodo() {
      if (!this.dti || !this.dtf) return [];
      const inicio = this.dti instanceof Date ? new Date(this.dti) : new Date(this.dti);
      inicio.setHours(0, 0, 0, 0);
      const fim = this.dtf instanceof Date ? new Date(this.dtf) : new Date(this.dtf);
      fim.setHours(0, 0, 0, 0);
      if (fim < inicio) return [];

      const dias = [];
      const cursor = new Date(inicio);
      while (cursor <= fim) {
        dias.push(this.formatDiaExtenso(cursor));
        cursor.setDate(cursor.getDate() + 1);
      }
      return dias;
    },
    diaVazio() {
      return { codigo: '-', envio: '-', validas: '-', bilhetagem: '-', manutencao: null };
    },
    async resolveIdsVeiculos(onResolved) {
      if (this.idVeiculosSelected.length > 0) {
        const ids = this.idVeiculosSelected;
        const catalog = { ...this.veiculosCatalogo };
        ids.forEach((id) => {
          const cached = this.$refs.veiculosSelect
            && this.$refs.veiculosSelect.getCachedSelectedItem
            && this.$refs.veiculosSelect.getCachedSelectedItem(id);
          if (cached) catalog[Number(id)] = cached;
        });
        this.veiculosCatalogo = catalog;
        onResolved(ids);
        return;
      }
      try {
        const { ids } = await this.resolveLazySelectIds('veiculosSelect', this.idVeiculosSelected, 'id_veiculo');
        this.veiculosCatalogo = {};
        onResolved(ids);
      } catch {
        this.loading = false;
      }
    },
    fetchHistoricoPorIds(ids, dti, dtf, onDone) {
      const chunkSize = 80;
      const chunks = [];
      for (let i = 0; i < ids.length; i += chunkSize) {
        chunks.push(ids.slice(i, i + chunkSize));
      }
      if (!chunks.length) {
        onDone([]);
        return;
      }

      const merged = [];
      let pending = chunks.length;
      let failed = false;

      chunks.forEach((chunk) => {
        apiController.request(apiController.endpoints.getHistoricoveiculoequipamento, {
          data: { ids: chunk, dti, dtf },
          onSuccess: (response) => {
            if (Array.isArray(response.data)) {
              merged.push(...response.data);
            }
            pending -= 1;
            if (pending === 0 && !failed) {
              onDone(merged);
            }
          },
          onError: () => {
            failed = true;
            this.loading = false;
          },
        });
      });
    },
    initialize() {
      this.getRelManutencaoTiposEquipamentos();
    },
    getRelManutencaoTiposEquipamentos() {
      apiController.request(apiController.endpoints.getRelmanutencaotiposequipamentos, {
        onSuccess: (response) => {
          this.relManutencaoTiposEquipamentos = {
            ...this.relManutencaoTiposEquipamentos,
            ...(response.data || {}),
          };
        },
      });
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          const dti = new Date();
          dti.setDate(dti.getDate() - 1);
          dti.setMonth(dti.getMonth() - 1);
          dti.setHours(0, 0, 0);
          this.dti = dti;

          const dtf = new Date();
          dtf.setDate(dtf.getDate() - 1);
          dtf.setHours(23, 59, 59);
          this.dtf = dtf;
        }
      });
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      const item = this.$refs.empresaSelect && this.$refs.empresaSelect.getCachedSelectedItem
        ? this.$refs.empresaSelect.getCachedSelectedItem(id)
        : null;
      this.empresaRazaoSocial = item && item.razao_social ? item.razao_social : null;
    },
    clearVeiculosSelection() {
      if (!this.idVeiculosSelected.length) return;
      this.syncingSelection = true;
      this.idVeiculosSelected = [];
      if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.setSelectedItems) {
        this.$refs.veiculosSelect.setSelectedItems([]);
      }
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
    },
    clearEquipamentosSelection() {
      if (!this.idEquipamentosSelected.length) return;
      this.syncingSelection = true;
      this.idEquipamentosSelected = [];
      if (this.$refs.equipamentosSelect && this.$refs.equipamentosSelect.setSelectedItems) {
        this.$refs.equipamentosSelect.setSelectedItems([]);
      }
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
    },
    populaDados() {
      this.loading = true;
      this.toPivot = [];
      this.historico = [];

      const dti = DateUtils.getDateSQLFormatted(this.dti);
      const dtf = DateUtils.getDateSQLFormatted(this.dtf);

      if (this.idEquipamentosSelected.length > 0) {
        this.byEquipamento = true;
        this.byVeiculo = false;

        const idsEquipamentos = this.idEquipamentosSelected;
        const equipamentoPorId = this.getEquipamentoSelectPorId();
        const idsVeiculos = [...new Set(
          idsEquipamentos
            .map((idEq) => {
              const equip = equipamentoPorId[Number(idEq)];
              return equip ? equip.id_veiculo : null;
            })
            .filter((id) => id != null)
        )];

        if (!idsVeiculos.length) {
          this.historico = [];
          this.historicoCompleto = [];
          this.loading = false;
          return;
        }

        this.fetchHistoricoPorIds(idsVeiculos, dti, dtf, (rows) => {
          this.toPivot = rows;
          this.buildHeaders();
          this.populaHistoricoEquipamentos(idsEquipamentos);
        });
        return;
      }

      this.byVeiculo = true;
      this.byEquipamento = false;
      this.resolveIdsVeiculos((idsVeiculos) => {
        if (!idsVeiculos.length) {
          this.historico = [];
          this.historicoCompleto = [];
          this.headersHistorico = [];
          this.headersHistoricoCompleto = [];
          this.loading = false;
          return;
        }
        this.fetchHistoricoPorIds(idsVeiculos, dti, dtf, (rows) => {
          this.toPivot = rows;
          this.buildHeaders();
          // Com "todos", prioriza veículos que têm histórico; se nenhum tiver, usa o catálogo.
          const idsComDados = [...new Set((rows || []).map((r) => Number(r.id_veiculo)))];
          const usarTodosSelecionados = this.idVeiculosSelected.length > 0;
          const idsParaTabela = usarTodosSelecionados
            ? idsVeiculos
            : (idsComDados.length ? idsComDados : idsVeiculos);
          this.populaHistoricoVeiculos(idsParaTabela);
        });
      });
    },
    buildHeaders() {
      let days = Array.from(new Set((this.toPivot || []).map((e) => e.dia_extenso).filter(Boolean)));
      if (!days.length) {
        days = this.diasDoPeriodo();
      }
      days.sort((a, b) => {
        const [da, ma, ya] = a.split('/').map(Number);
        const [db, mb, yb] = b.split('/').map(Number);
        return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
      });
      this.headersHistoricoCompleto = days.map((d) => ({
        text: d,
        value: d,
        filtrable: false,
        sortable: false,
        align: 'center',
      }));
      this.headersHistorico = this.headersHistoricoCompleto;
    },
    populaHistoricoVeiculos(idveiculos) {
      const dadosPorVeiculo = (this.toPivot || []).reduce((acc, data) => {
        const idVeiculo = Number(data.id_veiculo);
        if (!acc[idVeiculo]) {
          acc[idVeiculo] = [];
        }
        acc[idVeiculo].push(data);
        return acc;
      }, {});
      const dias = (this.headersHistorico || []).map((h) => h.value);

      this.historicoCompleto = idveiculos.map((v) => {
        const id = Number(v);
        const catalogo = this.veiculosCatalogo[id] || {};
        const h = {
          id_veiculo: id,
          numero_ordem: catalogo.numero_ordem || null,
          nome_tipo_equipamento: null,
        };
        dias.forEach((dia) => {
          h[dia] = this.diaVazio();
        });
        for (const data of (dadosPorVeiculo[id] || [])) {
          if (!h.numero_ordem && data.numero_ordem) {
            h.numero_ordem = data.numero_ordem;
          }
          if (!h.nome_tipo_equipamento && data.nome_tipo_equipamento) {
            h.nome_tipo_equipamento = data.nome_tipo_equipamento;
          }
          if (data.dia_extenso) {
            h[`${data.dia_extenso}`] = {
              codigo: data.cod_equipamento || '-',
              envio: data.p_envio,
              validas: data.p_validas,
              bilhetagem: data.total_bilhetagens,
              manutencao: data.manutencao,
            };
          }
        }
        return h;
      });
      this.historico = this.historicoCompleto;
      this.loading = false;
    },
    populaHistoricoEquipamentos(idequipamentos) {
      const dadosPorVeiculo = (this.toPivot || []).reduce((acc, data) => {
        const idVeiculo = Number(data.id_veiculo);
        if (!acc[idVeiculo]) {
          acc[idVeiculo] = [];
        }
        acc[idVeiculo].push(data);
        return acc;
      }, {});
      const dias = (this.headersHistorico || []).map((h) => h.value);
      const equipamentoPorId = this.getEquipamentoSelectPorId();

      this.historicoCompleto = idequipamentos.map((idEq) => {
        const equip = equipamentoPorId[Number(idEq)];
        const idVeiculo = equip ? Number(equip.id_veiculo) : Number(idEq);
        const h = {
          id_equipamento: idEq,
          id_veiculo: idVeiculo,
          numero_ordem: null,
          cod_equipamento: equip ? equip.cod_equipamento : null,
          nome_tipo_equipamento: equip ? equip.nome_tipo_equipamento : null,
        };
        dias.forEach((dia) => {
          h[dia] = this.diaVazio();
        });
        for (const data of (dadosPorVeiculo[idVeiculo] || [])) {
          if (!h.numero_ordem && data.numero_ordem) {
            h.numero_ordem = data.numero_ordem;
          }
          if (!h.nome_tipo_equipamento && data.nome_tipo_equipamento) {
            h.nome_tipo_equipamento = data.nome_tipo_equipamento;
          }
          if (data.dia_extenso) {
            h[`${data.dia_extenso}`] = {
              codigo: data.numero_ordem || '-',
              envio: data.p_envio,
              validas: data.p_validas,
              bilhetagem: data.total_bilhetagens,
              manutencao: data.manutencao,
            };
          }
        }
        return h;
      });
      this.historico = this.historicoCompleto;
      this.loading = false;
    },
    populaRelatorio() {
            this.$refs.form.validate();
            if (this.formValidado) {
              this.populaDados();
            }
        },
        updateSort(event) {
          this.sortBy = event;
        },
        updateSortDesc(event) {
          this.sortDesc = event;
        },
        getColorIcon(dia) {
            if (!dia || dia.envio === '-') {
              return 'grey';
            }
            if (dia.manutencao) {
              return 'red';
            }
            return 'green';
        },
        linkStatus(cod, tipo) {
          if(tipo == 1){
            this.$router.push({ path: `/statusequipamento/${cod}` })
          }
          else{
            let veiculo = this.toPivot.find(v => v.cod_avl == cod);
            if(veiculo){
              this.$router.push({ path: `/statusequipamento/${veiculo.numero_ordem}` })
            }
          }
        },
        abrirConfiguracoesLimites() {
          this.$router.push({ path: '/config' });
        },
        aplicarFiltros() {
          var filtrado = this.filtrarHistoricoPorDias(this.historicoCompleto);
          filtrado = this.filtrarPorStatusManutencao(filtrado);
          this.historico = filtrado;
          this.filtrarHeaders();
        },
        limparFiltros() {
          this.filtroDiasAtivo = null;
          this.filtroStatusManutencao = this.$t('operation.all');
        },
        filtrarHistoricoPorDias(historico) {
          if (this.filtroDiasAtivo === null || this.filtroDiasAtivo === undefined || this.filtroDiasAtivo <= 0) {
            return historico;
          }

          const hoje = new Date();
          hoje.setHours(0, 0, 0, 0);

          const dataInicial = new Date(hoje);
          dataInicial.setDate(hoje.getDate() - this.filtroDiasAtivo);

          const parseDataBrasileira = (dataStr) => {
            const [dia, mes, ano] = dataStr.split('/');
            return new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
          };

          const isDataNoPeriodo = (dataStr) => {
            if (!dataStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) return false;
            
            try {
              const dataRegistro = parseDataBrasileira(dataStr);
              return dataRegistro >= dataInicial && dataRegistro <= hoje;
            } catch (error) {
              console.warn(`${this.$t('relMaintenanceHistory.rules.invalidDate')}: ${dataStr}`);
              return false;
            }
          };

          return historico.map((item) => {
            const itemFiltrado = { ...item };
            
            Object.keys(item).forEach((key) => {
              if (key.match(/^\d{2}\/\d{2}\/\d{4}$/) && !isDataNoPeriodo(key)) {
                delete itemFiltrado[key];
              }
            });

            return itemFiltrado;
          });
        },
        filtrarHeaders() {
          const header = [];

          this.headersHistoricoCompleto.map((j) => {
            this.historico.map((i) => {
              Object.keys(i).forEach((key) => {
                if (key === j.value) {
                  header[key] = j;
                }
              });
            });
          });

          this.headersHistorico = Object.values(header);
        },
        filtrarPorStatusManutencao(historico) {
          if (this.filtroStatusManutencao === 'todos') {
            return historico;
          }
          
          return historico.map((item) => {
            const itemFiltrado = { ...item };

            Object.keys(item).forEach((key) => {
              if (this.filtroStatusManutencao === 'com_problemas') {
                if (key.match(/^\d{2}\/\d{2}\/\d{4}$/) && !item[key].manutencao) {
                  delete itemFiltrado[key];
                }
              } else if (this.filtroStatusManutencao === 'sem_problemas') {
                if (key.match(/^\d{2}\/\d{2}\/\d{4}$/) && item[key].manutencao) {
                  delete itemFiltrado[key];
                }
              }
            });

            return itemFiltrado;
         });
        },
    }
}
</script>

<style>
.no__wrap {
  white-space: nowrap;
}

.no__grey__lines tbody tr {
  background-color: white !important;
}
</style>
